import { ContentTableItem } from "src/components/ContentTable/ContentTable";

export function mapEventsToContentTableItems(
	allEvents: MeeEvent[]
): ContentTableItem[] {
	const liveEvents = allEvents.filter((e) => e.published);
	const draftEvents = allEvents.filter((e) => !e.published);

	const live = [...liveEvents]
		.sort((a, b) => {
			const aTime = new Date(a.startDate).getTime();
			const bTime = new Date(b.startDate).getTime();
			const aValid = Number.isFinite(aTime) ? aTime : Infinity;
			const bValid = Number.isFinite(bTime) ? bTime : Infinity;
			return aValid - bValid || a.id - b.id;
		})
		.map((event) => ({
			id: event.id,
			name: event.name,
			createdBy: event.createdBy
				? `${event.createdBy.firstName} ${event.createdBy.lastName}`
				: undefined,
			lastUpdated: event.updatedAt ?? event.createdAt,
			isActive: true,
			data: {
				startDate: event.startDate,
				endDate: event.endDate
			}
		}));

	const draft = [...draftEvents]
		.sort((a, b) => a.name.localeCompare(b.name))
		.map((event) => ({
			id: event.id,
			name: event.name,
			createdBy: event.createdBy
				? `${event.createdBy.firstName} ${event.createdBy.lastName}`
				: undefined,
			lastUpdated: event.updatedAt ?? event.createdAt,
			isActive: false,
			data: {
				startDate: event.startDate,
				endDate: event.endDate
			}
		}));

	return [...live, ...draft];
}
